import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

interface UseGetYourFoodStatusOptions {
  mealId: string | null;
  enabled?: boolean;
  refetchInterval?: number;
}

export const useGetYourFoodStatus = ({
  mealId,
  enabled = true,
  refetchInterval = 2000, // Poll every 2 seconds by default
}: UseGetYourFoodStatusOptions) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.YOUR_FOOD_STATUS, mealId],
    queryFn: async () => {
      if (!mealId) {
        throw new Error("Meal ID is required");
      }
      const user = guardGetUserFromLocalStorage();
      const { data } = await MealsService.getYourFoodStatusApiV1MealsYourFoodMealIdStatusGet(
        mealId,
        user.id,
      );
      return data;
    },
    enabled: enabled && !!mealId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      // Stop polling if status is completed or failed
      if (status === "completed" || status === "failed") {
        return false;
      }
      return refetchInterval;
    },
    retry: 10,
  });

  return {
    statusData: data,
    isLoading,
    isError,
    error,
  };
};
